export const videoQuizQuestion = (state, id) => (
    [...state.videoQuestions].filter(item => item.id !== id)
);


// WEBPACK FOOTER //
// ./src/utils/videoDataTransformation.js